jQuery(($) => {
    if ($('.o-history-timeline-slider')[0]) {

        $('.o-history-timeline-slider').each(function () {
            var slides     = $(this).find('.o-history-timeline-slider__slides'),
                yearSlides = $(this).find('.o-history-timeline-slider__year-slides'),
                slideCount = yearSlides.data('count'); 

            slides.slick({
                speed: 600,
                swipe: false,
                arrows: false,
                fade: true,
                responsive: [{
                    breakpoint: 600,
                    settings: {
                        adaptiveHeight: true
                    }
                }]
            });

            yearSlides.slick({
                mobileFirst: true,
                speed: 600,
                arrows: false,
                slidesToShow: slideCount - 1,
                variableWidth: false,
                responsive: [{
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: slideCount - 2,
                    },
                }, {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: slideCount - 3,
                    }
                }, {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: slideCount - 4,
                    }
                }, {
                    breakpoint: 950,
                    settings: {
                        adaptiveHeight: true
                    }
                }]
            });

            $('.o-history-timeline-slider__nav').slick({
                fade:true,
                asNavFor: '.o-history-timeline-slider__slides,.o-history-timeline-slider__year-slides'
            });
        });
    }
});